import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapGetters, mapActions, mapMutations } from 'vuex';
import taskDialog from './taskDialog.vue';
export default {
  components: {
    taskDialog
  },
  data() {
    return {
      couponObj: {
        showCoupon: false,
        // 控制优惠券弹窗显示
        couponImg: 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/cnytc2.png',
        // 优惠券弹窗图片地址
        couponTitle: '',
        // 优惠券弹窗标题
        contentText: '获得优惠券红包',
        // 优惠券弹窗内容
        score: 0,
        // 优惠券金额
        bgHeight: 356,
        bgWidth: 312
      }
    };
  },
  watch: {
    isAward: {
      handler(val) {
        if (val) {
          this.couponObj.bgHeight = 356;
          this.couponObj.couponImg = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/cnytc2.png';
          this.couponObj.score = 0;
          const {
            task_done_num
          } = this.checkInList;
          const {
            type,
            score
          } = this.awardObj;
          this.couponObj.couponTitle = `任务${task_done_num}完成`;
          if (type === 1) {
            this.couponObj.bgHeight = 387;
            this.couponObj.contentText = '获得现金红包';
            this.couponObj.score = score;
            this.couponObj.couponImg = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/yunying/default/cnytc1.png';
          } else {
            this.couponObj.contentText = '获得优惠券红包';
          }
          this.couponObj.showCoupon = true;
        }
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters('url', ['urlParams', 'isTaskOperate'])), mapGetters('login', ['isLogin'])), mapGetters('operateTask', ['taskNumObj', 'checkInList', 'isOperateFailed', 'isAward', 'awardObj', 'isClickTasked'])), {}, {
    opreateText() {
      const textObj = {
        numText: '',
        bottomText: '刷攻略 领红包'
      };
      const {
        num = 0,
        total = 20
      } = this.taskNumObj;
      const {
        finish = 0,
        task_total
      } = this.checkInList;
      const isTaskFinishedAll = finish || this.awardObj.type && this.awardObj.type === task_total;

      // 当前任务是否已经开奖完成
      const isCurrentTaskFinished = num === total && total !== 0 && this.isAward;
      if (!this.isLogin) {
        textObj.numText = '请登录';
        textObj.bottomText = '登录领红包';
      }
      // 任务失败
      else if (this.isOperateFailed) {
        textObj.numText = '活动火爆';
        textObj.bottomText = '请您稍后重试';
        return textObj;
      }
      //  finish===1 或者开奖接口返回任务全部完成，则任务全部完成
      else if (isTaskFinishedAll) {
        textObj.numText = '全部完成';
        textObj.bottomText = '明日再来领取';
        return textObj;
      } else if (isCurrentTaskFinished) {
        textObj.numText = '点击查看';
        textObj.bottomText = '获得奖励红包';
      } else if (total !== 0 && num <= total) {
        textObj.numText = `${num}/${total}`;
        textObj.bottomText = '刷攻略 领红包';
      }
      return textObj;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('login', ['goLogin'])), mapMutations('operateTask', ['setIsClickTasked'])), {}, {
    operateClick() {
      if (!this.isLogin) {
        this.goLogin();
        return;
      }
      if (this.isAward) {
        this.setIsClickTasked(true);
      }
      this.$emit('showOpreate', false);
    },
    closeCoupon() {
      this.couponObj.showCoupon = false;
    },
    clickContent() {
      this.closeCoupon();
      /* eslint-disable max-lines */
      const url = 'baidumap://map/cost_share?url=https%3A%2F%2Fcarowner.baidu.com%2ForderCenter%2Fcoupon.html&transparentWeb=0&navigationStatus=2&hiddenBackBtn=1&hiddenTitle=1&popRoot=no';
      window.location.href = url;
    }
  })
};